module.exports = __webpack_public_path__ + "img/pm.59a12514.png";